import { render, staticRenderFns } from "./ContainerAppeals.vue?vue&type=template&id=399998d8&"
import script from "./ContainerAppeals.vue?vue&type=script&lang=js&"
export * from "./ContainerAppeals.vue?vue&type=script&lang=js&"
import style0 from "./ContainerAppeals.vue?vue&type=style&index=0&id=399998d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports